module.exports = __webpack_public_path__ + "static/media/icon-talkroom-download.72459e4c.svg";